export const firstLetterCapitalized = (text = '') => {
  return text.charAt(0).toUpperCase() + text.slice(1)
}
